import CustomizeStyles from '../../../styles/Customize.module.css'
import { useState, useEffect, useRef, useCallback } from 'react'
import EasyCrop from '../../../components/EasyCrop'
import { useOutletContext } from 'react-router-dom'
import { uploadFileURL, getImage } from '../../../utils/filesystem'
import { isValidImg } from '../../../utils/files'
import Divider from '@mui/material/Divider';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import DeleteIcon from '@mui/icons-material/Delete';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { removeFile } from '../../../utils/filesystem'
import Helper from '../../../components/Helper'
import logoPlaceHolder from '../../../images/logo_placeholder.webp'
import bannerPlaceHolder from '../../../images/banner_placeholder.webp'
import { updateStore } from '../../../utils/database'
import Checkbox from '@mui/material/Checkbox';
import SaveBanner from '../../../components/SaveBanner'
import EasySnackBar from '../../../components/EasySnackBar'
import { USER_PLANS } from '../../../utils/structures'

export default function Customize() {

    const COLOR_CONSTANTS = ', 100%, 93%)'
    const IMAGE_QUALITY = 0.8

    const [userAuth, userData, userMenu, updateUserData, updateUserMenu, setPreventNavigation] = useOutletContext()

    const [storeModified, setStoreModified] = useState(false)

    const [logo, setLogo] = useState(undefined)
    const [banner, setBanner] = useState(undefined)
    const [loadedImg, setLoadedImg] = useState(null)
    const [isLogo, setIsLogo] = useState(false)

    const logoInputRef = useRef(null)
    const coverInputRef = useRef(null)

    const [color, setColor] = useState(0);
    const [blackAndWhite, setBlackAndWhite] = useState(false)

    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')

    // PORTADA RATIO 21:9

    const setNewBanner = useCallback(image => {
        setBanner(image)
        setPreventNavigation(true)
        setStoreModified(true)
    }, [setPreventNavigation])

    const setNewLogo = useCallback(image => {
        setLogo(image)
        setPreventNavigation(true)
        setStoreModified(true)
    }, [setPreventNavigation])

    const onUpdate = useCallback(async () => {

        //actualizar imagenes en el filesystem
        //actualizar links en el menu
        if (logo === null) {
            removeFile(userAuth.uid + '/logo.webp')
        } else if (logo && logo !== logoPlaceHolder) {
            uploadFileURL(logo, userAuth.uid + '/logo.webp')
        }

        if (banner === null) {
            removeFile(userAuth.uid + '/banner.webp')
        } else if (banner && banner !== bannerPlaceHolder) {
            uploadFileURL(banner, userAuth.uid + '/banner.webp')
        }

        if (color !== userMenu.color) {
            updateStore(userAuth, userData.menuid, { color: color })
        }

        setPreventNavigation(false)
        setStoreModified(false)
    }, [logo, userAuth, banner, color, userMenu, userData])

    const getImages = useCallback(async () => {
        const reqLogo = await getImage(userAuth.uid + '/logo.webp')
        const reqBanner = await getImage(userAuth.uid + '/banner.webp')

        setLogo(reqLogo ? URL.createObjectURL(reqLogo) : logoPlaceHolder)
        setBanner(reqBanner ? URL.createObjectURL(reqBanner) : bannerPlaceHolder)
    }, [userAuth])

    useEffect(() => {
        if (userMenu) {
            if (userMenu.color === -1) {
                setBlackAndWhite(true)
                setColor(0)
            } else {
                setColor(parseInt(userMenu.color))
            }
        }
    }, [userMenu])

    useEffect(() => {
        if (userAuth) {
            getImages()
        }
    }, [userAuth, getImages])


    useEffect(() => {
        if (userMenu.color !== color && color !== 0) {
            setStoreModified(true)
            setPreventNavigation(true)
        } else {
            setStoreModified(false)
            setPreventNavigation(false)
        }
    }, [color, setPreventNavigation, userMenu])

    const userImgLoad = useCallback(img => {
        if (!isValidImg(img)) {
            setErrorMessage('Imagen invalida, intenta con otra')
        } else {
            setLoadedImg(URL.createObjectURL(img))
        }
    }, [])

    if (loadedImg) {
        if (isLogo) {
            return <EasyCrop
                loadedImg={loadedImg}
                setLoadedImg={setLoadedImg}
                setImage={setNewLogo}
                aspectRatio={1 / 1}
                quality={IMAGE_QUALITY}
            />
        } else {
            return <EasyCrop
                loadedImg={loadedImg}
                setLoadedImg={setLoadedImg}
                setImage={setNewBanner}
                aspectRatio={21 / 9}
                quality={IMAGE_QUALITY}
            />
        }
    }

    return (
        <>
            <Stack>
                <Typography variant='h4'>Previsualizacion</Typography>
                <Stack sx={{ m: 2 }} style={{ backgroundColor: blackAndWhite ? 'hsl(0, 0%, 99%)' : 'hsl(' + color + ', 100%, 99%)' }}>
                    <label
                        className={CustomizeStyles.bannerInput}
                        style={banner ? { backgroundImage: "url(" + banner + ")" } : null}
                    >
                        <input type="file" accept='image/*' className={CustomizeStyles.imgInput} ref={coverInputRef}
                            onChange={e => {
                                setIsLogo(false)
                                userImgLoad(e.target.files[0])
                            }}
                        />
                    </label>

                    <label className={CustomizeStyles.logoInput} style={logo ? { backgroundImage: "url(" + logo + ")" } : null}>
                        <input type="file" accept='image/*' className={CustomizeStyles.imgInput}
                            onChange={e => {
                                setIsLogo(true)
                                userImgLoad(e.target.files[0])
                            }}
                            ref={logoInputRef}
                        />
                    </label>

                    <Typography variant="h3">{userMenu.title}</Typography>
                    <Typography className={CustomizeStyles.storeCaption} variant="body1">{userMenu.description}</Typography>
                </Stack>

                <Divider sx={{ m: 2 }} />

                <div className={CustomizeStyles.imagesActions}>
                    <ButtonGroup variant="contained" aria-label="outlined primary button group"
                        size='large'
                        sx={{ width: 'fit-content' }}
                    >
                        <Button color='error' onClick={() => { setNewLogo(null) }}>
                            <DeleteIcon />
                            Eliminar logo
                        </Button>
                        <Button onClick={() => logoInputRef ? logoInputRef.current.click() : null}>
                            <FileUploadIcon />
                            Cambiar logo
                        </Button>
                    </ButtonGroup>

                    <ButtonGroup variant="contained" aria-label="outlined primary button group"
                        size='large'
                        sx={{ width: 'fit-content' }}
                    >
                        <Button color='error' onClick={() => { setNewBanner(null) }}>
                            <DeleteIcon />
                            Eliminar portada
                        </Button>
                        <Button onClick={() => coverInputRef ? coverInputRef.current.click() : null}>
                            <FileUploadIcon />
                            Cambiar portada
                        </Button>
                    </ButtonGroup>
                </div>
            </Stack>

            <Stack spacing={2} sx={{ m: 2 }}>

                <Stack direction='row' gap='30px' alignItems='center'>
                    <Typography variant='h4'>
                        Cambiar color
                        <Helper text='El color que elijas se usará en algunas secciones de tu menú' />
                    </Typography>

                    <div
                        className={CustomizeStyles.prevColorContainer}
                        style={color < 0 ? { backgroundColor: 'white', border: '1px solid gray' } :
                            { backgroundColor: 'hsl(' + color + COLOR_CONSTANTS }}
                    >
                        <Typography variant='h6'>
                            Color actual
                        </Typography>
                    </div>

                </Stack>

                {userMenu.plan.type === USER_PLANS.free ?
                    <Typography variant='h6'>Para personalizar el color de tu negocio necesitas conseguir el plan PRO</Typography> :
                    <>
                        <Stack direction='row' spacing={1} alignItems='center'>
                            <Typography variant='h6'>
                                Estilo blanco y negro
                            </Typography>

                            <Checkbox
                                checked={blackAndWhite}
                                onChange={e => {
                                    if (e.target.checked) {
                                        setBlackAndWhite(true)
                                        setColor(-1)
                                    } else {
                                        setBlackAndWhite(false)
                                        setColor(1)
                                    }
                                }}
                            />
                        </Stack>

                        <div className={CustomizeStyles.colorsBanner}>
                            <Slider
                                aria-label="Color"
                                onChange={(event, newValue) => setColor(newValue)}
                                value={color}
                                max={360}
                                sx={{ color: 'rgb(25,25,25)' }}
                                disabled={color < 0}
                            />
                        </div>
                    </>}
            </Stack>

            <SaveBanner
                setPreventNavigation={setPreventNavigation}
                storeModified={storeModified}
                onUpdate={onUpdate}
            />

            <EasySnackBar
                severity='error'
                key='1'
                message={errorMessage}
                setMessage={setErrorMessage}
            />

            <EasySnackBar
                severity='success'
                key='2'
                message={successMessage}
                setMessage={setSuccessMessage}
            />
        </>
    )
}
